var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.517 17.629a.633.633 0 0 0 .881-.137l.43-.592c.172-.283.172-.676-.136-.9L14 13.33V5.661c0-.346-.287-.661-.633-.661h-.734c-.346 0-.633.315-.633.661V14a.65.65 0 0 0 .26.536zM24.323 13c0 6.222-5.038 11.323-11.323 11.323-6.222 0-11.323-5.038-11.323-11.323C1.677 6.778 6.715 1.677 13 1.677c6.222 0 11.323 5.038 11.323 11.323zM13 0C5.819 0 0 5.819 0 13s5.819 13 13 13 13-5.819 13-13S20.181 0 13 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.04c156571c2a086d1a35f670ef325e83.svg";
export { ForwardRef as ReactComponent };